import React from 'react';
import './Hero.css';

const Hero = ({ children }) => <div className="Hero">{children}</div>;

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero.js